<template lang="html">
  <el-tabs v-model="activeName" onclick="click" >
<!--    <el-tab-pane label="设置公众号" name="first">-->
<!--      <wechat-public-number></wechat-public-number>-->
<!--    </el-tab-pane> -->
    <!--<el-tab-pane label="商家入驻收费设置" name="second">-->
      <!--<business-free-config></business-free-config>-->
    <!--</el-tab-pane>-->
    <el-tab-pane label="首页icon导航" name="one">
      <navigation-management ref="navigation-management"></navigation-management>
    </el-tab-pane>
      <el-tab-pane label="底部tab导航" name="seven">
          <bottom-tab-config-management></bottom-tab-config-management>
      </el-tab-pane>
    <el-tab-pane label="模块配置" name="six">
      <index-tab-config-management></index-tab-config-management>
    </el-tab-pane>
    <el-tab-pane label="二手车设置" name="eight">
      <used-car-source-switch-management></used-car-source-switch-management>
    </el-tab-pane>
    <el-tab-pane label="车友圈分类" name="two">
      <car-circle-management ref="car-circle-management"></car-circle-management>
  </el-tab-pane>

    <el-tab-pane label="基础设置" name="five">
      <wechat-share-info></wechat-share-info>
    </el-tab-pane>

  </el-tabs>
</template>

<script>

import navigationManagement from '@/pages/setting/icon/navigationManagement.vue'
import carCircleManagement from '@/pages/setting/icon/carCircleManagement.vue'
import indexTabConfigManagement from '@/pages/setting/icon/indexTabConfigManagement.vue'
import usedCarSourceSwitchManagement from '@/pages/setting/icon/usedCarSourceSwitchManagement.vue'
import bottomTabConfigManagement from '@/pages/setting/icon/bottomTabConfigManagement.vue'

import WechatPublicNumber from '@/pages/setting/WechatPublicNumber'
import BusinessFreeConfig from '@/pages/setting/BusinessFreeConfig'
import HomeConfig from './HomeConfig'
import WechatShareInfo from '@/pages/setting/WechatShareInfo.vue'
export default {
  name: 'setting-index',
  components: {
    BusinessFreeConfig,
    WechatPublicNumber,
    WechatShareInfo,
    HomeConfig,
    navigationManagement,
    carCircleManagement,
    indexTabConfigManagement,
    usedCarSourceSwitchManagement,
    bottomTabConfigManagement
  },
  data: function () {
    return {
      activeName: 'one'
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    click: function (table, index) {

    }
  }
}
</script>

<style lang="css">
</style>
